// ============================================================
// CLIENT ONBOARDING CONFIG
// Replaces the 5 Google Sheet info-grab templates. The client's
// onboarding page is built from their service flags instead.
//
// To change which accounts we ask for per service, edit
// SERVICE_ACCESS below. Platform keys must match the keys the
// onboarding app understands (ACCESS_PLATFORMS).
// ============================================================

// Base URL of the client-facing onboarding app.
// Set REACT_APP_ONBOARDING_URL in Vercel once that app is deployed.
export const ONBOARDING_BASE_URL =
  (process.env.REACT_APP_ONBOARDING_URL || 'https://ONBOARDING-APP-URL-NOT-SET').replace(/\/$/, '')

// Services shown as checkboxes in Add Client. `planField` is the
// clients column + label revealed when the box is checked.
export const SERVICES = [
  { flag: 'has_website',     label: 'Website',     icon: '🌐', planField: 'plan_website',     placeholder: 'e.g. "basic updates as needed & SEO optimization"' },
  { flag: 'has_ads',         label: 'Ads',         icon: '📣', planField: 'plan_ads',         placeholder: 'e.g. "up to $6K in monthly ad spend"' },
  { flag: 'has_seo',         label: 'SEO',         icon: '🔎', planField: 'plan_seo_blogs',   placeholder: 'e.g. "2 SEO-optimized blogs per month"' },
  { flag: 'has_social',      label: 'Social',      icon: '📱', planField: 'plan_social',      placeholder: 'e.g. "15 posts per month, plus reels"' },
  { flag: 'has_newsletters', label: 'Newsletters', icon: '✉️', planField: 'plan_newsletters', placeholder: 'e.g. "2 newsletters per month via HubSpot"' },
  { flag: 'has_blogs',       label: 'Blogs',       icon: '📝', planField: 'plan_seo_blogs',   placeholder: 'e.g. "2 SEO-optimized blogs per month"' },
]

// Every account we might request access to.
export const ACCESS_PLATFORMS = {
  website:       'Website',
  hosting:       'Website hosting',
  domain:        'Domain',
  ga4:           'Google Analytics',
  gsc:           'Google Search Console',
  gbp:           'Google Business Profile',
  google_ads:    'Google Ads',
  meta_business: 'Meta Business Suite / Facebook Page',
  instagram:     'Instagram',
  linkedin:      'LinkedIn',
  newsletter:    'Newsletter / Email Marketing Provider',
}

// Which accounts each service needs. A platform needed by more
// than one checked service is only created once.
export const SERVICE_ACCESS = {
  has_website:     ['website', 'hosting', 'domain', 'ga4'],
  has_ads:         ['google_ads', 'ga4', 'meta_business', 'website'],
  has_seo:         ['website', 'hosting', 'domain', 'ga4', 'gsc', 'gbp'],
  has_social:      ['meta_business', 'instagram', 'linkedin'],
  has_newsletters: ['newsletter'],
  has_blogs:       ['website'],
}

/** Unique list of platform keys for a set of service flags. */
export function platformsForServices(flags) {
  const out = []
  Object.keys(SERVICE_ACCESS).forEach(flag => {
    if (!flags[flag]) return
    SERVICE_ACCESS[flag].forEach(p => { if (!out.includes(p)) out.push(p) })
  })
  return out
}

/** 64-char random hex token, generated in the browser. */
export function generateOnboardingToken() {
  const bytes = new Uint8Array(32)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('')
}

export function onboardingUrlFor(token) {
  return `${ONBOARDING_BASE_URL}/o/${token}`
}
